import {debounce} from 'lodash';
import {useEffect, useMemo} from 'react';

export const useDebouncedCallback = <F extends (...args: any) => any>(callback: F, delay = 500) => {
    const debouncedChangeHandler = useMemo(() => debounce(callback, delay), [callback, delay]);

    useEffect(() => {
        return () => {
            debouncedChangeHandler.cancel();
        };
    }, [debouncedChangeHandler]);

    return debouncedChangeHandler;
};
